module.exports = __webpack_public_path__ + "static/media/table-column.7b3b5335.svg";